import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { CoreApiService } from '../../../../core/service/core-api-service';
import { AppService } from '../../../../core/service/app.service';
import { properties } from '../../../../../environments/properties';
import { StoreModel } from '../../../../model/store.model';
import { STORE_STATUS_CONFIG, StoreStatusEnum } from '../../../../model/store-status.model';

@Component({
  selector: 'app-my-store-detail',
  standalone: true,
  imports: [CommonModule, ButtonModule, TableModule, RouterLink],
  templateUrl: './my-store-detail.component.html',
  styleUrl: './my-store-detail.component.css',
})
export class MyStoreDetailComponent implements OnInit {
  storeInfo: StoreModel | null = null;
  loading: boolean = false;
  errorMessage: string | null = null;

  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
  ) {}

  ngOnInit(): void {
    this.getStore();
  }

  getStore(): void {
    this.loading = true;
    this.errorMessage = null;
    this.apiService.consumirWSGet(properties.serviceMyStoreGet, null, (data) => {
      this.loading = false;
      if (data.estado === properties.codeOK && data.data) {
        this.storeInfo = data.data;
      } else {
        this.errorMessage = data.mensaje || 'No se pudo cargar la información del negocio';
        this.util.mostrarToast('Mi Negocio', this.errorMessage ?? '', 3);
      }
    });
  }

  // GET my-store solo trae el id del estado; el nombre se resuelve con el catálogo local.
  get statusName(): string {
    const id = this.storeInfo?.sto_store_status_id as StoreStatusEnum | undefined;
    return (id && STORE_STATUS_CONFIG[id]?.name) || 'Desconocido';
  }

  getDayName(dayOfWeek: number): string {
    const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    return days[dayOfWeek];
  }
}
